import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { QueuePages, WorkQueueDetails, LenderRESL, WorkQueueModel, WorkQueueUpdateModel } from './work-queue.model';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { GridSettings } from '../../../shared/components/customized-grid/grid-settings/gird-settings.interface';
import { process } from '@progress/kendo-data-query';


@Injectable({
  providedIn: 'root',
})
export class WorkQueueService {
  APIEndpoint: string;

  public CurrentQueueSubject: BehaviorSubject<WorkQueueDetails>;
  public CurrentQueue$: Observable<WorkQueueDetails>;

  constructor(private http: HttpClient, private datePipe: DatePipe, private toastrService: ToastrService) {}

  GetWorkQueue(workQueueType: number, workqueueStatusId: number,
    accountUpdateOptionId: number, customerFollowUpOptionId: number, investigationOptionId: number, insuranceFollowUpOptionId: number): Observable<WorkQueueDetails> {

    return this.http
      .get<WorkQueueDetails>(
        `${AppConfig.settings.settings.apiEndpoint}api/WorkQueue/GetWorkQueueDetails/?workQueueType=` +
          workQueueType + '&workqueueStatusId=' + workqueueStatusId 
          + '&accountUpdateOptionId=' + (accountUpdateOptionId === -1 ? '' : accountUpdateOptionId)
          + '&customerFollowUpOptionId=' + (customerFollowUpOptionId === -1 ? '' : customerFollowUpOptionId)
          + '&investigationOptionId=' + (investigationOptionId === -1 ? '' : investigationOptionId)
          + '&insuranceFollowUpOptionId=' + (insuranceFollowUpOptionId === -1 ? '' : insuranceFollowUpOptionId)

      )
      .pipe(
        map(
          data => {
            if (data != null && data != undefined) {
              this.CurrentQueueSubject = new BehaviorSubject<WorkQueueDetails>(data);
              this.CurrentQueue$ = this.CurrentQueueSubject.asObservable();

              data.workQueueModels.map(w => {
                w.policydatereceived = !w.policydatereceived ? null : new Date(new Date(w.policydatereceived).toDateString());
                w.policyremediationdate = !w.policyremediationdate ? null : new Date(new Date(w.policyremediationdate).toDateString());
                w.followupdate = !w.followupdate ? null : new Date(new Date(w.followupdate).toDateString());
                w.reportdate = !w.reportdate ? null : new Date(new Date(w.reportdate).toDateString());
                w.lastvieweddate = !w.lastvieweddate ? null : new Date(new Date(w.lastvieweddate).toDateString());
                w.resladvancedate = !w.resladvancedate ? null : new Date(new Date(w.resladvancedate).toDateString());
                w.policyeffectivedate = !w.policyeffectivedate ? null : new Date(new Date(w.policyeffectivedate).toDateString());
              });            
            }
            return data;
          },
          error => {
            return of([]);
          }
        )
      );
  }

  GetQueuePages(): Observable<QueuePages[]> {
    return this.http
      .get<QueuePages[]>(
        `${AppConfig.settings.settings.apiEndpoint}api/RolePermission/GetSubPagesbyPage/Work Queues`
      )
      .pipe(
        map(
          data => {
            return data;
          },
          error => {
            return of([]);
          }
        )
      );
  }

  updateQueue(workQueueUpdateModel: WorkQueueUpdateModel){
    
    return this.http
      .post<number>(
        `${AppConfig.settings.settings.apiEndpoint}api/WorkQueue/UpdateQueue`,
        workQueueUpdateModel
      )
      .pipe(
        map(value => {
          return value;
        })
    );
  }

  GetDefaultGridSetting(state: any, data: WorkQueueModel[]): GridSettings
  {
     return {
       state: state,
       gridData: process(data,state),
      columnsConfig: [
        {
          field: 'id',
          hidden: true,
          filterable: false,
          width: 30,

        },
        {
          field: 'reportdate',
          filter: 'date',
          filterable: true,
          format: 'yyyy-MM-dd',
          hidden: false,
          title: 'Report date',
          type: 'date',
          width: 93,
        },
        {
          field: 'insurecorporationcode',
          //filter: 'multicheck',
          filterable: false,
          hidden: false,
          title: 'Insurance Company Name',
          width: 60,
        },
        {
          field: 'policynumber',
          filterable: true,
          hidden: false,
          title: 'Policy Number',
          routerLink: '/accountview',
          width: 120,
        },
        {
          field: 'noticetypepolicy',
          filterable: true,
          hidden: false,
          title: 'Notice Type (Policy)',
          //routerLink: '/accountview',
          width: 120,
        },        
        {
          field: '',
          filterable: true,
          hidden: false,
          title: 'RESL Type',
          //routerLink: '/accountview',
          width: 120,
        },
        {
          field: 'productaccountnomortgage',
          filterable: true,
          hidden: false,
          title: 'Product Account number',
          //routerLink: '/accountview',
          width: 120,
        },
        {
          field: 'borrow1',
          filterable: true,
          hidden: false,
          //routerLink: '/accountview',
          title: 'Borrower 1',
          width: 120,
        },
        {
          field: 'borrow2',
          filterable: true,
          hidden: false,
          //routerLink: '/accountview',
          title: 'Borrower 2',
          width: 120,
        },
        {
          field: 'mortgageprincipalbalance',
          filterable: true,
          hidden: false,
          //routerLink: '/accountview',
          title: 'Mortgage Principal Balance',
          width: 120,
        },

        {
          field: 'policyeffectivedate',
          filter: 'date',
          filterable: true,
          format: 'yyyy-MM-dd',
          hidden: false,
          title: 'Insurance Effective Date',
          type: 'date',
          width: 93,
        },
        {
          field: 'fullmatch',
          filterable: true,
          filter: 'boolean',
          hidden: false,
          title: 'Full Match - Coverage Sufficient (True/False)',
          width: 93,
        },
        {
          field: 'insufficientamount',
          filter: 'numeric',
          filterable: true,
          hidden: false,
          title: 'Full Match - Insufficient Coverage Amount $',
          type: 'currency',
          width: 95,
        },
        {
          field: 'nomatch',
          filterable: true,
          filter: 'boolean',
          hidden: false,
          title: 'No Match(True / False)',
          width: 93,
        },
        {
          field: 'partialmatch',
          filterable: true,
          hidden: false,
          title: 'Partial Match',
          width: 93,
        },
        {
          field: 'reason',
          filterable: true,
          hidden: false,
          title: 'Partial Match Reasons',
          width: 93,
        },
        {
          field: 'workqueuestatusid',
          filterable: true,
          hidden: false,
          title: 'Status',
          type: 'queueStatus',
          width: 93,
        },

        {
          field: 'workqueueaccountupdateoptionid',
          filterable: true,
          hidden: false,
          title: 'Account Update',
          type: 'assignStatus',
          width: 108,
        },
        {
          field: 'workqueuecustomerfollowupoptionid',
          filterable: true,
          hidden: false,
          title: 'Customer Followup',
          type: 'assignStatus',
          width: 108,
        },
        {
          field: 'workqueueinsurancefollowupoptionid',
          filterable: true,
          hidden: false,
          title: 'Insurance Followup',
          type: 'assignStatus',
          width: 108,
        },
        {
          field: 'workqueueinvestigationoptionid',
          filterable: true,
          hidden: false,
          type: 'assignStatus',
          title: 'Investigation',
          width: 108,
        },
        {
          field: 'updateflag',
          filterable: true,
          filter: 'boolean',
          hidden: false,
          title: 'Updated Info (True/False)',
          width: 93,
        },
        {
          field: 'updatebyuser',
          filterable: true,
          hidden: false,
          title: 'Last Modified By',
          width: 62,
        },
        {
          field: 'lastvieweddate',
          filter: 'date',
          filterable: true,
          format: 'yyyy-MM-dd',
          hidden: false,
          title: 'Last Reviewed Date',
          type: 'date',
          width: 93,
        },
        {
          field: 'lastcomments',
          filterable: true,
          hidden: false,
          title: 'Latest Comments',
          width: 93,
        },

      ],
    };
  
  }
}
